export default "__VITE_ASSET__BRK7Usdx__"